import { apiGet } from './client';
import type { UserSummary } from './auth';

export interface ConsoleMe {
  user: UserSummary;
  permissions: string[];
  groups: { id: number; name: string }[];
}

export async function fetchMe(): Promise<ConsoleMe> {
  return apiGet('/me/');
}
